import React, { Fragment } from 'react';
import styled from 'styled-components';

import Admin from 'hive-admin';
import PageSingle from 'hive-admin/src/components/PageSingle';

import { Link } from 'react-router-dom';

import {
  UserOutlined,
  ShoppingOutlined,
  UnorderedListOutlined,
  BarcodeOutlined,
  LayoutOutlined,
  DashboardOutlined,
} from '@ant-design/icons';

import tests from '../../helpers/tests';

// import clickAnchor from '../../helpers/clickAnchor';
// import getStoreUrl from '../../helpers/getStoreUrl';

import { createChangeLogSection } from '../../components/FieldChangeLog';

import {
  FIELDS_CREATE,
  FIELDS_WEBSITE,
  FIELDS_ACCOUNT,
  FIELDS_NAVIGATION,
  FIELDS_STYLE,
  FIELDS_SHOP,
  FIELDS_SHIPPING,
  FIELDS_LEGAL,
  FIELDS_AI,

  getI18nFields,

  activationFormModalConfig,
} from './fields';
import { FIELDS as FIELDS_ADMIN_STYLE } from './fields/adminStyle';
import { FILTERS } from './filters';
import { COLUMNS } from './columns';

import Types from '../../modules/types';

import './index.less';

const {
  CONSTANTS: {
    StoreSubscriptionMode,
  },
} = Types;

class PageSingleStore extends PageSingle {
  renderHeaderDescription() {
    const description = this.props.renderHeaderDescription(this.props);
    if (!description) {
      return null;
    }
    return (
      <div
        key="page-header-description"
        className="page-header-description"
        style={{ zoom: 0.8 }}
      >
        {description}
      </div>
    );
  }
}

Admin.addToLibrary('PageSingleStore', config => PageSingleStore.create(config));

const {
  viewerIsAdmin,
  viewerIsNotAdmin,
  viewerIsNotSeller,
  viewerIsAdminAndDoesNotHavePermission,
} = tests;

// const ActionOpenStoreWithToken = Admin.compileFromLibrary(['Action', {
//   name: 'offers',
//   title: 'Browse Offers',
//   ghost: true,
//   skip: [
//     props => !props.data || !props.data.active,
//   ],
//   onClick: (props) => clickAnchor({
//     url: getStoreUrl(props.data),
//     query: {
//       token: props.client.getAccessToken(),
//       // fields: JSON.stringify({
//       //   country: props.data.systemCountry,
//       //   lastName: props.viewer.name.split(/\s+/)[0],
//       //   email: props.viewer.email,
//       //   phoneNumber: props.viewer.phoneNumber,
//       //   firstName: props.viewer.name.split(/\s+/)[1],
//       //   billing: {
//       //     firstName: null,
//       //     lastName: null,
//       //     email: null,
//       //     phoneNumber: null,
//       //     country: null,
//       //     city: null,
//       //     postalCode: null,
//       //     line1: null,
//       //   },
//       //   // "shipping": "ABSTRACT",
//       //   city: props.data.address.city,
//       //   postalCode: props.data.address.postalCode,
//       //   coordinates: props.data.address.coordinates,
//       //   line1: props.data.address.line1,
//       //   line2: props.data.address.line2,
//       //   payment: 'CARD',
//       // }),
//     },
//   }, {
//     target: '_blank',
//   }),
// }]);

const PAGES = [
  {
    title: 'Website',
    path: 'website',
    fields: [
      ...FIELDS_WEBSITE,
      ...createChangeLogSection({
        changeLogConfig: {
          getWhereConditions: props => ({
            store: props.data?._id,
            'target.type': 'Store',
            'target.subject': props.data._id,
          }),
          skipColumns: {
            store: true,
            realm: true,
            target: true,
          },
        },
      }),
    ],
    config: {
      getPageFields: getI18nFields,
    },
    adminConfig: {
      // eslint-disable-next-line max-len
      loadUrl: '/stores/:id/?includeCategories=true&includeCollections=true&includeLanguagesList=true&includeIntegrations=true',
    },
    sellerConfig: {
      // eslint-disable-next-line max-len
      loadUrl: '/stores/me/?includeCategories=true&includeCollections=true&includeLanguagesList=true&includeIntegrations=true',
    },
  },
  {
    title: 'Account',
    path: 'account',
    fields: FIELDS_ACCOUNT,
    getSkipHeaderItem: props => props.viewer && props.viewer.role !== 'ADMIN',
    config: {
      skip: [props => props.viewer && props.viewer.role !== 'ADMIN'],
    },
  },
  {
    title: 'Enterprise',
    path: 'enterprise',
    fields: FIELDS_ADMIN_STYLE,
    getSkipHeaderItem: props => props.viewer && props.viewer.role !== 'ADMIN',
    config: {
      skip: [props => props.viewer && props.viewer.role !== 'ADMIN'],
    },
  },
  {
    title: 'Navigation',
    path: 'navigation',
    fields: FIELDS_NAVIGATION,
    config: {
      getPageFields: getI18nFields,
    },
  },
  {
    title: 'Style',
    path: 'style',
    fields: FIELDS_STYLE,
  },
  {
    title: 'Shop',
    path: 'shop',
    fields: FIELDS_SHOP,
    adminConfig: {
      loadUrl: '/stores/:id/?includeCategories=true&includeCollections=true',
    },
    sellerConfig: {
      loadUrl: '/stores/me/?includeCategories=true&includeCollections=true',
    },
  },
  {
    title: 'Shipping',
    path: 'shipping',
    fields: FIELDS_SHIPPING,
  },
  {
    title: 'AI',
    path: 'ai',
    fields: FIELDS_AI,
  },
  {
    title: 'Legal',
    path: 'legal',
    fields: FIELDS_LEGAL,
  },
];

const NavigationBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
  &:last-child {
    margin-bottom: 16px;
  }
`;

const NavigationItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  justify-content: flex-start;
  align-items: center;
  user-select: none;
`;

const NavigationItemHTML = ({ active, to, ...props }) => (
    active
  ? <span {...props} />
  : <Link to={to} {...props} />
);

const NavigationItem = styled(NavigationItemHTML)`
  &[data-navigation-item-size="large"] {
    font-size: 130%;
    color: ${props => (
        props.active
      ? props.theme.less.primaryColor
      : props.theme.less.textColor
    )};
    text-decoration: ${props => (props.active ? 'underline' : 'none')};
    &:hover {
      color: ${props => props.theme.less.primaryColor};
    }
  }
`;

const NavigationItemSeparator = styled.div`
  padding: 0px 10px;
  display: flex;
  transform: translateY(-1px);
  flex-shrink: 0;
  opacity: 0.4;
`;

const renderHeaderDescription = props => (
    props.data
  ? (
      <Fragment key="header-description">
        <NavigationBlock style={{ marginTop: '20px' }}>
          {
            PAGES
            .filter(({ skipHeaderItem, getSkipHeaderItem }) => (
              !skipHeaderItem
              && (
                !getSkipHeaderItem
                || !getSkipHeaderItem(props)
              )
            ))
            .reduce(
              (agr, { title, path }, i, array) => {
                agr.push(
                  <NavigationItemWrapper key={title}>
                    <NavigationItem
                      data-navigation-item-size="large"
                      active={path === props.id}
                      key={title}
                      to={path}
                    >
                      {title}
                    </NavigationItem>
                    {
                      i < array.length - 1
                      ? (
                          <NavigationItemSeparator key={`${title}-sep`}>
                            |
                          </NavigationItemSeparator>
                        )
                      : null
                    }
                  </NavigationItemWrapper>
                );
                return agr;
              },
              [],
            )
          }
        </NavigationBlock>
        {
          props.viewer && props.viewer.role === 'ADMIN'
          ? (
              <NavigationBlock>
                <span style={{ paddingRight: '8px' }}>
                  Open this store&apos;s:
                </span>
                {[
                  [
                    'Analytics',
                    '/analytics/views',
                    DashboardOutlined,
                  ],
                  ['Sellers', '/users/sellers', UserOutlined],
                  ['Orders', '/orders', ShoppingOutlined],
                  ['Categories', '/categories', UnorderedListOutlined],
                  ['Products', '/products', BarcodeOutlined],
                  ['Pages', '/website/pages', LayoutOutlined],
                ].reduce(
                  (agr, [label, url, IconComponent], i, array) => {
                    agr.push(
                      <NavigationItemWrapper key={label}>
                        <NavigationItem
                          key={label}
                          to={`${url}?store=${props.data._id}`}
                        >
                          <IconComponent />
                          {' '}
                          {label}
                        </NavigationItem>
                        {
                          i < array.length - 1
                          ? (
                              <NavigationItemSeparator key={`${label}-sep`}>
                                |
                              </NavigationItemSeparator>
                            )
                          : null
                        }
                      </NavigationItemWrapper>
                    );
                    return agr;
                  },
                  [],
                )}
              </NavigationBlock>
            )
          : null
        }
        {
          props.viewer && props.viewer.role === 'SELLER'
          ? (
              <NavigationBlock>
                <span style={{ paddingRight: '8px' }}>
                  Open your:
                </span>
                {[
                  [
                    'Analytics',
                    '/analytics/views',
                    DashboardOutlined,
                  ],
                  ['Orders', '/store/orders', ShoppingOutlined],
                  ['Categories', '/store/categories', UnorderedListOutlined],
                  ['Products', '/store/products', BarcodeOutlined],
                  ['Pages', '/website/pages', LayoutOutlined],
                ].reduce(
                  (agr, [label, url, IconComponent], i, array) => {
                    agr.push(
                      <NavigationItemWrapper key={label}>
                        <NavigationItem
                          key={label}
                          to={`${url}`}
                        >
                          <IconComponent />
                          {' '}
                          {label}
                        </NavigationItem>
                        {
                          i < array.length - 1
                          ? (
                              <NavigationItemSeparator key={`${label}-sep`}>
                                |
                              </NavigationItemSeparator>
                            )
                          : null
                        }
                      </NavigationItemWrapper>
                    );
                    return agr;
                  },
                  [],
                )}
              </NavigationBlock>
            )
          : null
        }
      </Fragment>
    )
  : null
);

const cannotActivateNorDeactivateStore = (email) => (
  [
    /@thehive\.rs$/,
    /^yara@packman\.app$/,
    /^abdulaziz@packman\.app$/,
    /^saleh@packman\.app$/,
    /^amr@packman\.app$/,
    /^ali@packman\.app$/,
    /^mhd@packman\.app$/,
    /^elias@packman\.app$/,
    /^awais@packman\.app$/,
    /^usman@packman\.app$/,
  ].findIndex(
    emailTest => emailTest.test(email || '')
  ) === -1
);

const {
  adminPages,
  sellerPages,
} = PAGES.reduce(
  (
    agr,
    {
      title,
      path,
      fields,
      config = {},
      adminConfig = {
        skip: [viewerIsAdminAndDoesNotHavePermission('stores')],
      },
      sellerConfig = {},
    },
  ) => {
    agr.adminPages.push(Admin.compileFromLibrary(['PageSingleStore', {
      ...agr.defaultConfig,
      ...agr.defaultAdminConfig,
      id: path,
      path: `/stores/:id/${path}`,
      title,
      fields,
      ...config,
      ...adminConfig,
    }]));
    agr.sellerPages.push(Admin.compileFromLibrary(['PageSingleStore', {
      ...agr.defaultConfig,
      ...agr.defaultSellerConfig,
      id: path,
      path: `/store/${path}`,
      title,
      headerTitle: title,
      fields,
      ...config,
      ...sellerConfig,
    }]));
    return agr;
  },
  {
    adminPages: [],
    sellerPages: [
      ['Page', {
        path: '/store',
        hidden: true,
        exact: true,
        redirect: [
          ['redirect.unauthorized'],
          ['redirect.always', '/store/website'],
        ],
      }],
    ],
    defaultConfig: {
      exact: true,
      useTrash: false,
      activity: 'edit',
      saveMethod: 'patch',
      notFoundMessage: 'Store not found!',
      loadExtractData: response => (response ? response.data : null),
      renderHeaderDescription,
      actions: [
        Admin.compileFromLibrary(['ActionSaveAndReload']),
        // ActionOpenStoreWithToken,
        Admin.compileFromLibrary(['ActionWithFormModal', {
          ...activationFormModalConfig,
          skip: [
            props => (
              !props.data
              || props.data.active
              || props.data.subscriptionMode === StoreSubscriptionMode.ONLINE
            ),
          ],
          actions: [
            ['ActionWithRequest', {
              name: 'activate-action',
              title: 'Request Store Activation',
              ghost: false,
              style: { marginTop: '20px', width: '100%' },
              getRequestConfig: props => ({
                url: `stores/${props.data._id}/actions/activate`,
                data: props.form.getFieldsValue(),
                method: 'POST',
              }),
              messageSuccess: [
                'Activation request sent!',
                'Someone will be in touch shortly.',
              ].join(' '),
              handleSuccess: (data, props) => props.reload(),
            }],
          ],
          getRequestConfig: props => ({
            url: `stores/${props.data._id}/actions/activate`,
            data: {},
            method: 'POST',
          }),
          messageSuccess: [
            'Activation request sent!',
            'Someone will be in touch shortly.',
          ].join(' '),
          handleSuccess: (data, props) => props.reload(),
        }]),
        Admin.compileFromLibrary(['Action', {
          name: 'activate-link',
          title: 'Start Selling NOW!',
          ghost: true,
          skip: [
            viewerIsAdmin,
            props => (
                !props.data
              || props.data.active
              || props.data.subscriptionMode !== StoreSubscriptionMode.ONLINE
            ),
          ],
          onClick: (props) => {
            props.history.push('/store/subscription')
          },
        }]),
      ],
    },
    defaultAdminConfig: {
      loadUrl: '/stores/:id',
      saveUrl: '/stores/:id',
      deleteUrl: '/stores/:id',
      alias: '/stores',
      hidden: true,
      redirect: [
        Admin.compileFromLibrary(['redirect.unauthorized']),
        Admin.compileFromLibrary([
          'redirect.checkViewer',
          'role', '!==', 'ADMIN',
          '/store/website',
        ]),
      ],
      actions: [
        Admin.compileFromLibrary(['ActionSaveAndReload']),
        // ActionOpenStoreWithToken,
        Admin.compileFromLibrary(['ActionWithRequest', {
          name: 'activate',
          title: 'Activate',
          ghost: true,
          skip: [
            viewerIsNotAdmin,
            props => (
              !props.data
              || props.data.active
              || viewerIsAdminAndDoesNotHavePermission(
                'storesActivation'
              )(props)
            ),
          ],
          getRequestConfig: props => ({
            url: `stores/${props.data._id}/actions/activate`,
            data: {},
            method: 'POST',
          }),
          handleSuccess: (data, props) => props.reload(),
        }]),
        Admin.compileFromLibrary(['ActionWithRequest', {
          name: 'onboard',
          title: 'Set As Onboarded',
          ghost: true,
          skip: [
            viewerIsNotAdmin,
            props => (
              !props.data
              || props.data.onboardingComplete
              // || cannotActivateNorDeactivateStore(props.viewer?.email)
            ),
          ],
          getRequestConfig: props => ({
            url: `stores/${props.data._id}/actions/onboard`,
            data: {},
            method: 'POST',
          }),
          handleSuccess: (data, props) => props.reload(),
        }]),
        Admin.compileFromLibrary(['ActionWithRequest', {
          name: 'deactivate',
          title: 'Deactivate',
          ghost: true,
          skip: [
            viewerIsNotAdmin,
            props => (
              !props.data
              || !props.data.active
              || viewerIsAdminAndDoesNotHavePermission(
                'storesActivation'
              )(props)
            ),
          ],
          getRequestConfig: props => ({
            url: `stores/${props.data._id}/actions/deactivate`,
            data: {},
            method: 'POST',
          }),
          handleSuccess: (data, props) => props.reload(),
        }]),
        Admin.compileFromLibrary(['ActionWithRequest', {
          name: 'archive',
          title: 'Archive',
          popconfirm: 'Archiving store will schedule it for deletion!',
          ghost: true,
          skip: [
            viewerIsNotAdmin,
            props => !props.data || props.data.archived,
          ],
          getRequestConfig: props => ({
            url: `stores/${props.data._id}/actions/archive`,
            data: {},
            method: 'POST',
          }),
          handleSuccess: (data, props) => props.reload(),
        }]),
        // Admin.compileFromLibrary(['ActionWithRequest', {
        //   name: 'pay',
        //   title: 'Pay',
        //   popconfirm: 'Try paying using store card?',
        //   ghost: true,
        //   skip: [
        //     viewerIsNotAdmin,
        //     // props => !props.data || props.data.archived,
        //   ],
        //   getRequestConfig: props => ({
        //     url: `stores/${props.data._id}/pay`,
        //     data: {},
        //     method: 'POST',
        //   }),
        //   handleSuccess: (data, props) => props.reload(),
        // }]),
        Admin.compileFromLibrary(['ActionDelete']),
      ],
    },
    defaultSellerConfig: {
      loadUrl: '/stores/me',
      saveUrl: '/stores/me',
      hidden: [viewerIsNotSeller],
      redirect: [
        ['redirect.unauthorized'],
        [
          'redirect.checkViewer',
          'role', '!==', 'SELLER',
          '/stores',
        ],
      ],
    },
  },
);

export default [
  ...adminPages,
  ...Admin.compileFromLibrary(['GroupResource', {
    title: 'Stores',
    icon: 'shop',
    path: '/stores',
    skip: [viewerIsAdminAndDoesNotHavePermission('stores')],
    redirect: [
      ['redirect.unauthorized'],
      [
        'redirect.checkViewer',
        'role', '!==', 'ADMIN',
        '/store',
      ],
    ],
    filters: FILTERS,
    columns: COLUMNS,
    archiveConfig: {
      icon: 'shop',
      title: 'Stores',
      label: 'Stores',
      loadUrl: '/stores/list',
      createButtonPath: '/stores/create',
      hidden: [viewerIsNotAdmin],
    },
    singleConfig: {
      hidden: true,
      alias: '/stores',
      headerTitle: 'Create Store',
      backButtonPaths: ['/stores'],
    },
    singleCreateConfig: {
      fields: FIELDS_CREATE,
    },
    singleEditConfig: {
      fields: [],
      redirect: [
        ['redirect.unauthorized'],
        [
          'redirect.checkViewer',
          'role', '!==', 'ADMIN',
          '/store',
        ],
        ['redirect.always', ({ match: { params } }) => (
          params?.id
          ? `/stores/${params.id}/website`
          : '/stores'
        )],
      ],
    },
  }]).pages,
  ['Group', {
    id: 'store',
    icon: 'shop',
    title: 'My Store',
    hidden: [viewerIsNotSeller],
    pages: sellerPages,
  }],
];
